import { render, staticRenderFns } from "./roamView.vue?vue&type=template&id=3f439db5&scoped=true&"
import script from "./roamView.vue?vue&type=script&lang=js&"
export * from "./roamView.vue?vue&type=script&lang=js&"
import style0 from "./roamView.vue?vue&type=style&index=0&id=3f439db5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f439db5",
  null
  
)

export default component.exports